<script setup lang="ts" generic="T extends MultiSelectOption">
import Button from '../Button/Button.vue'
import Icon from '../Icon/Icon.vue'
import { MultiSelectOption } from './types'
</script>

<template>
  <Button class="text-neutral-dark-6 hover:text-neutral-dark-6/60 p-1 pr-0">
    <Icon
      class="h-4 w-4"
      icon="circle-xmark"
    />
  </Button>
</template>
